import lastSeen from 'assets/core/js/module/last-seen'
import snippet from 'assets/core/js/page/homepage/content/snippet'
import dataLayer from 'assets/core/js/page/homepage/datalayer'
import searchForm from 'assets/themes/campings/js/module/searchForm'
import alertError from 'assets/themes/campings/js/page/homepage/alert-error'
import cms from 'assets/themes/campings/js/page/homepage/cms'
import crossBorder from 'assets/themes/campings/js/page/homepage/cross-border'
import exclusiveDealsPush from 'assets/themes/campings/js/page/homepage/exclusive-deals'
import form from 'assets/themes/campings/js/page/homepage/form'
import topDestinationsSlider from 'assets/themes/campings/js/page/homepage/top-destinations-slider'

document.addEventListener('DOMContentLoaded', function () {
  cms()
  form()
  alertError()
  dataLayer()
  exclusiveDealsPush()
  topDestinationsSlider()

  searchForm()
  snippet()
  lastSeen()
  crossBorder()
})
